<script>
import MppdStatistik from '@/components/dashboard/mppd/Statistik.vue'
import MppdPerBulan from '@/components/dashboard/mppd/PerBulan.vue'
import MppdTabelJenisProfesi from '@/components/dashboard/mppd/TabelJenisProfesi.vue'
import MppdTabelFayankes from '@/components/dashboard/mppd/TabelFayankes.vue'
import MppdDonutJenisKelamin from '@/components/dashboard/mppd/RatioJenisKelamin.vue'
import MppdPieRatioFayankes from '@/components/dashboard/mppd/RatioFayankes.vue'

export default {
   components: {
      MppdStatistik,
      MppdPerBulan,
      MppdTabelJenisProfesi,
      MppdTabelFayankes,
      MppdDonutJenisKelamin,
      MppdPieRatioFayankes,
   },
}
</script>

<template>
   <div>
      <MppdStatistik />
      <MppdPerBulan />

      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <MppdTabelJenisProfesi />
         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <MppdTabelFayankes />
         </b-col>
      </b-row>

      <b-row class="mt-1">
         <b-col cols="12" md="6" class="mb-1">
            <MppdDonutJenisKelamin />
         </b-col>
         <b-col cols="12" md="6" class="mb-1">
            <MppdPieRatioFayankes />
         </b-col>
      </b-row>
   </div>
</template>

<style scoped></style>
